import { GET_ACCOUNT, LOGOUT, SET_ACCOUNT_IS_LOADING, UPDATE_ACCOUNT, GET_CUSTOMER_ACCOUNT, UPDATE_CUSTOMER_ACCOUNT, SET_CUSTOMER_ACCOUNT_IS_LOADING, } from "./types";
export function updateAccount(account) {
    return {
        type: UPDATE_ACCOUNT,
        payload: account,
    };
}
export function setAccountIsLoading(isLoading) {
    return {
        type: SET_ACCOUNT_IS_LOADING,
        payload: isLoading,
    };
}
export function getAccount(clientKey) {
    return {
        type: GET_ACCOUNT,
        payload: clientKey,
    };
}
export function updateCustomerAccount(account) {
    return {
        type: UPDATE_CUSTOMER_ACCOUNT,
        payload: account,
    };
}
export function setCustomerAccountIsLoading(isLoading) {
    return {
        type: SET_CUSTOMER_ACCOUNT_IS_LOADING,
        payload: isLoading,
    };
}
export function getCustomerAccount() {
    return {
        type: GET_CUSTOMER_ACCOUNT,
    };
}
export function logout() {
    return {
        type: LOGOUT,
    };
}
